// @flow

import type { Merchant } from '../types';
import { getMerchantConfig } from '../get-merchant-config';

export function getPartnerLogoUrl(merchant: Merchant): string {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig && merchantConfig.payment_page_partner_logo_url
    ? String(merchantConfig.payment_page_partner_logo_url)
    : '';
}
